module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('v-card', [_c('v-data-table', {
    attrs: {
      "headers": _vm.headers,
      "items": _vm.countries,
      "footer-props": _vm.footerProps
    },
    scopedSlots: _vm._u([{
      key: "item",
      fn: function(ref) {
        var item = ref.item;

        return [_c('tr', [_c('td', [_c('span', {
          class: _vm.flagIcon(item.alpha2)
        }), _vm._v("\n          " + _vm._s(item.name) + "\n        ")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.alpha2))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.numeric))])])]
      }
    }])
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// /export/jenkins/workspace/dev-isrs-frontend-mb_dev/~/vue-loader/lib/template-compiler?{"id":"data-v-edd13f7a"}!/export/jenkins/workspace/dev-isrs-frontend-mb_dev/~/vue-loader/lib/selector.js?type=template&index=0!./client/views/Countries.vue
// module id = 958
// module chunks = 1